import React,{useState,useEffect} from 'react'
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import db, { app,auth } from "./firebase"
import Geocode from "react-geocode";
import "./TweetBox.css"
import { storage } from './firebase';
import { getDownloadURL, getStorage, ref, uploadBytes, uploadBytesResumable } from "firebase/storage"
import { Button } from 'react-bootstrap';



const TweetBox=() =>{
  const [addLat,setAddLat] = useState<number|null>(null)
  const [addLng,setAddLng] = useState<number|null>(null)
  const [tweetMessage,setTweetMessage] = useState<string>("")
  const [tweetImage , setTweetImage] = useState<string|null>(null) 
  const [postImage, setPostImage] = useState<any>(null)
  const [spot,setSpot]= useState<string>("");
   
  const defineSpot =()=>{
    geocode();
   }

   const geocode:any =  () =>{
    Geocode.setApiKey("AIzaSyAGQ3UnxYDs-DziKsRr1fLqatZCM0o9Fm0");
    Geocode.fromAddress(spot).then((res:any) =>{
        console.log(res.results[0].geometry.location)
        const new_addLat:number = res.results[0].geometry.location.lat
        const new_addLng:number = res.results[0].geometry.location.lng
        setAddLat(new_addLat)
        setAddLng(new_addLng)
        window.alert("取得成功！！")
      },
      (error:any) =>{
        window.alert("取得できませんでした！！");
        setAddLat(null)
        setAddLng(null)
      }
    )
   }

  
   const OnFileUpLoadToFirebase = (e: any)=>{
    const file = e.target.files[0]
    try{
    const storageRef = ref(storage,"image/" + file.name)
    const uploadTask = uploadBytesResumable(storageRef,file)
    uploadTask.on("state_changed",()=>{
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL)=>{
        setTweetImage(downloadURL)
      })})
    }
    catch(error){
      window.alert("画像が正しく認識できませんでした")
      return;
    }
 };

  const sendTweet = async (e:any)=>{
   
    e.preventDefault()
    if (tweetMessage ==='') return;
        
        await addDoc(collection(db,"posts"), {
          displayName:auth.currentUser?.displayName,
          aid:auth.currentUser?.uid,
          verified:true,
          text:tweetMessage,
          avatar:auth.currentUser?.photoURL,
          pic:tweetImage,
          price:spot,
          location:{lat:addLat,lng:addLng},
          timestamp:serverTimestamp()
        });
        
      setTweetMessage("");
      setTweetImage("");
      setPostImage(null)
      setSpot("")
      setAddLat(null)
      setAddLng(null)
  }
 
 
 
  return (
    <div className='tweetBox'>
      <form>
       <div className='tweetBox--input'>
        <input
         value={tweetMessage}
         placeholder='こんなとこにいったよ！' type="text"
         onChange={(e)=>setTweetMessage(e.target.value)}
        >
        </input>
       </div>
        <input 
        className='tweetBox--imageInput'  type="file" 
        accept=".png, .jpeg, .jpg" onChange={OnFileUpLoadToFirebase} >
        </input>
        <input value={spot} className='tweetBox--price' placeholder='スポットを入力' type={"text"} onChange={(e)=>{setSpot(e.target.value)}}>
        </input>
        <Button onClick={defineSpot}>位置取得</Button>
       <div className='tweetbox--last'>
        <button className='tweetBox--tweetButton' type='submit'
        onClick={sendTweet}>投稿する</button>
       </div>
      </form>
    </div>
  )
}

export default TweetBox



